
import $ from 'zepto'
import {wxShareConfig} from '../js/common/utils'
import configInfo from "../configInfo.js"
import Flexbox from 'vux/src/components/flexbox/flexbox.vue'
import FlexboxItem from 'vux/src/components/flexbox/flexbox-item.vue'
import Tabbar from 'vux/src/components/tabbar/tabbar.vue'
import TabbarItem from 'vux/src/components/tabbar/tabbar-item.vue'
import Tab from 'vux/src/components/tab/tab.vue'
import TabItem from 'vux/src/components/tab/tab-item.vue'
import ButtonTab from 'vux/src/components/button-tab/button-tab.vue'
import ButtonTabItem from 'vux/src/components/button-tab/button-tab-item.vue'
import Scroller from 'vux/src/components/scroller/index.vue'
import Divider from 'vux/src/components/divider/index.vue'
import XSwitch from 'vux/src/components/x-switch/index.vue'
import Group from 'vux/src/components/group/index.vue'
import Spinner from 'vux/src/components/spinner/index.vue'

import Vue from 'vue'
import wx from 'wx'
import LeagueOngoingArrange from './leagueOngoing_arrange.vue'
import LeagueOngoingJifen from './leagueOngoingJifen.vue'
import LeagueShooters from './leagueShooters.vue'
import LeagueMoments from './leagueMoments.vue'
import LeagueData from './leagueData.vue'
import LeagueHeader from "../components/LeagueHeader"

export default {
props: {
leagueId: String,
},
components: {
Tab,
TabItem,
Tabbar,
TabbarItem,
Scroller,
Divider,
XSwitch,
Group,
Spinner,
ButtonTab,
ButtonTabItem,
Flexbox,
FlexboxItem,
LeagueHeader,
LeagueOngoingArrange,
LeagueOngoingJifen,
LeagueShooters,
LeagueMoments,
LeagueData
},
destroyed(){

},
computed: {},
mounted(){

document.body.style.backgroundColor = 'transparent'



if(this.$route.fullPath.indexOf('/league_ongoing/moments') > -1){
this.currentTab = "leagueMoments";
}else if(this.$route.fullPath.indexOf('/league_ongoing/jifen') > -1){
this.currentTab = "leagueTable";
}else if(this.$route.fullPath.indexOf('/league_ongoing/shooters') > -1){
this.currentTab = "shooterList";
}else if(this.$route.fullPath.indexOf('/league_ongoing/data') > -1){
this.currentTab = "leagueData";
}else{
this.currentTab = "leagueArrange";
}

if (this.$route.query.matchStatus) {
this.matchStatus = this.$route.query.matchStatus
} else {
this.matchStatus = "league-1";
}
var that = this;
this.hagkHttp(this.hagkApi.getLeagueBasic(this.id), {})
.then((res) => {

if (res.status == true) {
var leagueBasic = {};
leagueBasic.title = res.result.name;
leagueBasic.league_status = res.result.event_status;
leagueBasic.league_start_time = res.result.start_date;
leagueBasic.league_logo = res.result.logo;
this.leagueBasicInfo = leagueBasic;
this.$store.commit('updateLeagueBasicInfo', leagueBasic);
document.title = this.leagueBasicInfo.title

















this.initPage();
}
}, (error) => {

});

this.eventHub.$on('setTabIndex', (tabName) => {
this.currentTab = tabName;
console.log("setTabIndex "+ tabName);
});

this.eventHub.$on('resetView', () => {
this.$nextTick(() => {
this.$refs.scroller.reset();
})
})

this.eventHub.$on('enableloadMore', () => {
setTimeout(() => {
this.$refs.scroller.donePullup()
}, 10)
})

this.eventHub.$on('enablerefreshTab', () => {
this.$nextTick(() => {
setTimeout(() => {
this.$refs.scroller.donePulldown()
this.pullupEnabled && this.$refs.scroller.enablePullup()
}, 10)
})
})

},
methods: {
handlerLeagueArrange(){
this.currentTab = 'leagueArrange';
this.$router.push({
path: "/league_ongoing/arrange",
query: {leagueId:this.id}
})
},
handlerLeagueJifen(){
this.currentTab = 'leagueTable';
this.$router.push({
path: "/league_ongoing/jifen",
query: {leagueId:this.id}
})
},
handlerLeagueShooters(){
this.currentTab = 'shooterList';
this.$router.push({
path: "/league_ongoing/shooters",
query: {leagueId:this.id}
})
},
handlerLeagueData(){
this.currentTab = 'leagueData';
this.$router.push({
path: "/league_ongoing/data",
query: {leagueId:this.id}
})


},
handlerLeagueMoments(){
this.currentTab = 'leagueMoments';
this.$router.push({
path: "/league_ongoing/moments",
query: {leagueId:this.id}
})


},
initPage(){
if (this.currentTab == 'leagueArrange') {
$('#leagueArrangeTab').triggerFastClick();
} else if (this.currentTab == 'leagueMoments') {
$('#leagueMomentsTab').triggerFastClick();
} else if (this.currentTab == 'shooterList') {
$('#leagueShootersTab').triggerFastClick();
} else if (this.currentTab == 'leagueTable') {
$('#leagueJifenTab').triggerFastClick();
} else if (this.currentTab == 'leagueData') {
$('#leagueDataTab').triggerFastClick();
}
},
refreshTab(){
if (this.currentTab == 'leagueArrange') {
this.eventHub.$emit("refreshTabArrange");

} else if (this.currentTab == 'leagueMoments') {
this.eventHub.$emit("refreshTabMoments");

} else if (this.currentTab == 'shooterList') {
this.eventHub.$emit("refreshTabShooters");

} else if (this.currentTab == 'leagueTable') {
this.eventHub.$emit("refreshTabJifen");

} else if (this.currentTab == 'leagueData') {
this.eventHub.$emit("refreshTabData");

}
return;
},
loadMore(){
if (this.currentTab == 'leagueArrange') {
this.eventHub.$emit("loadMoreArrange");

} else if (this.currentTab == 'leagueMoments') {
this.eventHub.$emit("loadMoreMoments");

} else if (this.currentTab == 'shooterList') {
this.eventHub.$emit("loadMoreShooters");

} else if (this.currentTab == 'leagueTable') {
this.eventHub.$emit("loadMoreJifen");

} else if (this.currentTab == 'leagueData') {
this.eventHub.$emit("loadMoreData");

}
return;
}
},
data () {
var tabNames = ["赛程", "积分榜", "射手榜", "数据", "精彩瞬间"];
var loadingTab = ['leagueArrange', 'leagueTable', ' shooterList', 'leagueData', 'leagueMoments'];
this.$store.commit('updateEventHub', new Vue());

return {
id:this.$route.query.leagueId,
show1: false,
text1: 'Processing',
currentTab: 'leagueArrange',
matchStatus: '',
eventHub: this.$store.getters.getEventHub,
pulldownConfig: {
content: '下拉刷新',
height: 90,
autoRefresh: false,
downContent: '下拉刷新',
upContent: '松开刷新',
loadingContent: '加载中...',
clsPrefix: 'xs-plugin-pulldown-'
},
pullupConfig: {
content: '上滑加载更多',
pullUpHeight: 60,
height: 40,
autoRefresh: false,
downContent: '松开加载',
upContent: '上滑加载更多',
loadingContent: '加载中...',
clsPrefix: 'xs-plugin-pullup-'
},
roundStart: 0,
roundLength: 5,
roundsInfo: [],
roundUnstartStart: 0,
roundUnstartLength: 5,
roundsUnstartInfo: [],
tabNames: tabNames,
getBarWidth: function (index) {
if ((this.index) >= 0) {
return tabNames[this.index].length * 22 + 'px'
}
},
leaguetimeDiv: {
marginBottom: '2px',
width: '14px',
height: '14px',
backgroundImage: 'url(' + require('../assets/img/time.png') + ')',
backgroundSize: '14px 14px',
},
leagueBasicInfo: {},
pullupEnabled: true,
status: {
pullupStatus: 'default',
pulldownStatus: 'default'
}
}
}
}



// WEBPACK FOOTER //
// ./src/views/leagueOngoing.vue